import React, { Component } from 'react';
import "react-toggle/style.css";
/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import EditIcon from '@material-ui/icons/Edit';
import AccessIcon from '@material-ui/icons/Accessibility';
import ReorderIcon from '@material-ui/icons/Reorder';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import IconButton from '@material-ui/core/IconButton';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
/* Routes */
import { S } from '../../../routes/routes'
/* Sagas Action */
import { actions as notificationActions } from '../../../redux/ducks/notification'
import { safeDeepGetWithType } from 'iotera-base/json';
import { isInteger, isEmpty, isFunction } from 'iotera-base/object';
import { getWidthColumnByPercent } from '../../../lib/components/function';
import { TablePaginationActionsWrapped, CustomTableCell } from '..';
import { setEditRoleDirect, setRoleEmpty } from '../../../testActions';
import { store } from '../../../testStore';
import { ioteraConfirmAlert } from '../../../lib/components/react/react-confirm-alert';

class RolesTable extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.goTo = this.goTo.bind(this);
    this.state = {
      tooltipOpen: false,
      page: 0,
      rowsPerPage: 10,
      dropdownOpen: {}
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete = (id) => event => {
    let handleDelete = safeDeepGetWithType(this, ['props', 'handleDelete']);
    if (isFunction(handleDelete)) {
      ioteraConfirmAlert(
        'Konfirmasi Hapus Role',
        'Apakah anda yakin ingin menghapus role ini?',
        null,
        () => handleDelete(id),
        null,
        null
      )
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage))
      rowsPerPage = parseInt(rowsPerPage)
    this.setState({ page: 0, rowsPerPage });
  };

  toggle() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    _this.setState({
      tooltipOpen: !_state.tooltipOpen
    });
  }

  onMouseEnter(key) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown visible 
    dropdownOpen[key] = true;
    _this.setState({ dropdownOpen });
  }

  onMouseLeave(key) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden 
    dropdownOpen[key] = false;
    _this.setState({ dropdownOpen });
  }

  handleAllCheck = event => {
    this.props.onCheckedRole(event.target.checked)
  }

  goTo(link) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    if (link === 'delete') {
      _props.showSingleNotification({ message: 'Maaf, fitur hapus role belum tersedia', position: 'tr', level: 'info' });
    } else if (link.includes('_role_edit_sort_')) {
      let emptyFirst = setRoleEmpty()
      store.dispatch(emptyFirst)
      let directAction = setEditRoleDirect(true)
      store.dispatch(directAction)
      _props.history.push(link)
    } else {
      _props.history.push(link)
      let emptyFirst = setRoleEmpty()
      store.dispatch(emptyFirst)
    }
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let data = _props.data;
    let navs = _props.navs;
    let emptyNavs = false;
    if (isEmpty(navs)) {
      emptyNavs = true;
    }
    let tableWidth = safeDeepGetWithType(_props, ['tableSize', 'width'], 0);
    const { rowsPerPage, page } = _state;
    let roleRows = []
    let first = true;
    let firstMore = true;
    let alreadyMore = false;
    Object.keys(data).forEach((key, index) => {
      let cardContent = data[key];
      let tags = []
      let tagsMore = []
      let j = 0;
      let roleLength = 0;
      let sizeTags = 0;
      let sizeTagsMore = 0;
      for (let i = 0; i < cardContent.navs.length; i++) {
        if (cardContent.navs[i] === null) {
          continue;
        }
        roleLength += cardContent.navs[i].length;
        if (roleLength > 60) {
          alreadyMore = true;
        }
        if (sizeTags >= 6 || alreadyMore === true) {
          if (firstMore === true) {
            firstMore = false;
          } else {
            tagsMore.push(', ')
          }
          sizeTagsMore++;
          tagsMore.push(cardContent.navs[i])
        } else {
          if (first === true) {
            first = false;
          } else {
            tags.push(<span key={key + j++} style={{ color: '#f00' }}>,&nbsp;</span>)
          }
          sizeTags++;
          tags.push(
            <span key={key + j++}>
              <span className="tag-component-iotera">{cardContent.navs[i]}</span>
            </span>
          )
        }
      }
      if (((sizeTags >= 6) && (sizeTagsMore !== 0)) || (alreadyMore === true)) {
        tags.push(
          <span key={key + j++}>
            <Tooltip TransitionComponent={Zoom} title={tagsMore} placement='bottom-start' enterDelay={500} >
              <span data-tip data-for={'...' + key} >, ...</span>
            </Tooltip>
          </span>
        )
      }
      // get dropdown is open or not
      let dropdownIsOpen = safeDeepGetWithType(_state, ['dropdownOpen', index], false);
      roleRows.push(
        <TableRow key={index} className='table-row-child-iotera'>
          <TableCell component="th" scope="row" column='role' style={{ textAlign: 'left' }}>
            <span><b>{cardContent.name}</b></span>
          </TableCell>
          <TableCell column='description' style={{ textAlign: 'left' }}>
            <span><i>{cardContent.description}</i></span>
          </TableCell>
          <TableCell column='navs'>
            <span>
              {tags}
            </span>
          </TableCell>
          <TableCell column='settings' onMouseLeave={(e) => _this.onMouseLeave(index)} style={{ textAlign: 'center' }}>
            <UncontrolledDropdown isOpen={dropdownIsOpen}>
              <DropdownToggle tag="div">
                <IconButton onMouseOver={(e) => _this.onMouseEnter(index)} style={{ cursor: 'pointer', padding: 4 }}>
                  <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
                </IconButton>
              </DropdownToggle>
              <DropdownMenu style={{ padding: 0, margin: 0 }}>
                <DropdownItem style={{ margin: 0 }} onClick={(e) => _this.goTo('.' + S + '_role_edit_role_' + S + cardContent.id)}>
                  <EditIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span style={{ marginRight: 20 }}>Edit Info</span>
                </DropdownItem>
                {!emptyNavs &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => _this.goTo('.' + S + '_role_edit_access_' + S + cardContent.id)}>
                    <AccessIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span
                      style={{ marginRight: 20 }}>Atur Akses</span>
                  </DropdownItem>
                }
                {sizeTags > 0 &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => _this.goTo('.' + S + '_role_edit_sort_' + S + cardContent.id)}>
                    <ReorderIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span style={{ marginRight: 20 }}>Reorder</span>
                  </DropdownItem>
                }
                <DropdownItem style={{ margin: 0 }} onClick={_this.handleDelete(cardContent.id)}>
                  <DeleteIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span style={{ marginRight: 20 }}>Hapus</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </TableCell>
        </TableRow >
      )
      first = true;
      firstMore = true;
      alreadyMore = false;
    })
    return (
      <Table className="table"
      >
        <TableHead style={{ height: 0 }}>
          <TableRow>
            <CustomTableCell column='role' style={{ textAlign: 'left', minWidth: getWidthColumnByPercent(25, tableWidth),
             maxWidth: getWidthColumnByPercent(25, tableWidth) }}><span>Role</span></CustomTableCell >
            <CustomTableCell column='description' style={{ textAlign: 'left', minWidth: getWidthColumnByPercent(25, tableWidth), 
            maxWidth: getWidthColumnByPercent(25, tableWidth) }}><span>Deskripsi</span></CustomTableCell >
            <CustomTableCell column='navs' style={{ textAlign: 'left', minWidth: getWidthColumnByPercent(40, tableWidth), 
            maxWidth: getWidthColumnByPercent(40, tableWidth) }}><span>Akses</span></CustomTableCell >
            <CustomTableCell column='settings' style={{ textAlign: 'center', minWidth: getWidthColumnByPercent(10, tableWidth), 
            maxWidth: getWidthColumnByPercent(10, tableWidth) }}><span>Aksi</span></CustomTableCell >
          </TableRow>
        </TableHead>
        <TableBody>
          {roleRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
              labelRowsPerPage='Baris terlihat:'
              rowsPerPageOptions={[5, 10, 25]}
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                native: true,
              }}
              onPageChange={_this.handleChangePage}
              onChangeRowsPerPage={_this.handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActionsWrapped}
            />
          </TableRow>
        </TableFooter>
      </Table>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(notificationActions, dispatch)
});

export default connect(null, mapDispatchToProps)(RolesTable);